import { useState, useCallback } from "react";
import { shareLink } from "@/utils/browser";
import type { SnackbarProps } from "@/components/shared/Snackbar/snackbar.types";

type ShareLinkOptions = {
  title: string;
  url?: string;
};

const useShareLink = () => {
  const [snackbarData, setSnackbarData] = useState<SnackbarProps>({
    show: false,
    message: ""
  });

  const handleCloseSnackbar = useCallback(() => {
    setSnackbarData({ show: false, message: "" });
  }, []);

  const handleShareLink = useCallback(
    async (options: ShareLinkOptions) => {
      const result = await shareLink(options);

      if (result) {
        setSnackbarData({
          show: true,
          message: "Link copiado com sucesso!"
        });

        setTimeout(() => {
          handleCloseSnackbar();
        }, 5000);

        return result;
      }
    },
    [handleCloseSnackbar]
  );

  return {
    snackbarData,
    handleShareLink,
    handleCloseSnackbar
  };
};

export default useShareLink;
